var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseModal',{staticClass:"country-switcher-modal",attrs:{"title":_vm.modalTitle}},[_c('div',{staticClass:"country-switcher-modal-content"},[_c('div',{key:"country"},[_c('CountryList',{attrs:{"additionalContexts":_vm.additionalContexts},on:{"selected-country":_vm.closeSelf}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }